import { Link } from 'react-router-dom';
import { articles } from '@/mocks/clCommunityData';

export default function LatestPosts() {
  const latestPosts = articles.slice(0, 8);

  return (
    <section className="bg-background-100 py-14 md:py-16">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
              最新帖子
            </h2>
            <p className="text-sm text-foreground-500 mt-1">实时更新的社区讨论与分享</p>
          </div>
        </div>

        <div className="bg-background-50 rounded-xl border border-background-200/70 overflow-hidden">
          {latestPosts.map((article, index) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className={`flex items-center gap-4 px-5 md:px-6 py-4 hover:bg-background-100/60 transition-colors cursor-pointer ${
                index < latestPosts.length - 1 ? 'border-b border-background-200/50' : ''
              }`}
            >
              <div className="hidden sm:flex w-8 h-8 rounded-full bg-background-100 items-center justify-center shrink-0">
                <span className="text-xs font-medium text-foreground-500">{index + 1}</span>
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm md:text-base font-medium text-foreground-900 line-clamp-1 hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <div className="flex items-center gap-3 mt-1">
                  <span className="text-xs text-foreground-500">@{article.author.name}</span>
                  <span className="text-xs bg-secondary-100 text-secondary-700 px-2 py-0.5 rounded-full font-medium">
                    {article.categoryName}
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-3 text-xs text-foreground-500 shrink-0">
                <span className="hidden sm:flex items-center gap-1">
                  <i className="ri-eye-line"></i>
                  {article.views >= 10000 ? `${(article.views / 10000).toFixed(1)}万` : article.views}
                </span>
                <span className="flex items-center gap-1">
                  <i className="ri-thumb-up-line"></i>
                  {article.likes}
                </span>
                <span>{article.publishedAt}</span>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-6 text-center">
          <Link
            to="/category/tech-discussion"
            className="inline-flex items-center gap-2 px-6 py-2.5 bg-background-50 border border-background-200 text-foreground-700 rounded-lg hover:bg-background-100 transition-all text-sm font-medium cursor-pointer"
          >
            浏览全部帖子
            <i className="ri-arrow-right-line text-xs"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}